export enum UserVerificationProviders {
	EMAIL = "EMAIL",
	PHONE = "PHONE",
}
